




















































































































































































import mixins from 'vue-typed-mixins';
import E2EMixin from '@/components/mixins/E2EMixin';
// @ts-ignore
import CvDesignSelect from '@/components/CvDesignSelect.vue';
import * as CvsStore from '@/containers/cvs/store';
import { Cv, CvDesignTemplateSample, CvSample } from '@/../gen';
import { i18n, i18nHints } from '@/plugins/i18n';
import CvExampleSelect from '@/components/cv-example-select/CvExampleSelect.vue';
import {
  makeInputValue,
  inputValueToPayload,
} from '@/components/cv-example-select/utils';

const SCRATCH_FLAG = 'SCRATCH_FLAG';
const DESIGN_TEMPLATE_SAMPLE = 'DESIGN_TEMPLATE_SAMPLE';
const CV_EXAMPLE = 'CV_EXAMPLE';
const COPY_CREATED_CV = 'COPY_CREATED_CV';

export default mixins(E2EMixin).extend({
  components: {
    CvDesignSelect,
    CvExampleSelect,
  },
  props: {
    cvs: {
      type: Array as () => Cv[],
      required: true,
    },
    cvDesignTemplateSamples: {
      type: Array as () => CvDesignTemplateSample[],
      required: true,
    },
    cvExamples: {
      type: Array as () => CvSample[],
      required: true,
    },
  },
  data() {
    return {
      formData: {
        title: null,
        templateCvDesignTemplateSelected: null,
        templateCvExampleSelected: null,
        copyCvSelected: null,
        initialCvType: DESIGN_TEMPLATE_SAMPLE,
      },
    };
  },
  computed: {
    SCRATCH_FLAG: () => SCRATCH_FLAG,
    DESIGN_TEMPLATE_SAMPLE: () => DESIGN_TEMPLATE_SAMPLE,
    CV_EXAMPLE: () => CV_EXAMPLE,
    COPY_CREATED_CV: () => COPY_CREATED_CV,
  },
  created() {
    if (this.cvDesignTemplateSamples.length)
      this.formData.templateCvDesignTemplateSelected = this.cvDesignTemplateSamples[0].cv_design_template_id;
    if (this.cvExamples.length)
      this.formData.templateCvExampleSelected = makeInputValue(
        this.cvExamples[0]
      );
    if (this.cvs.length) this.formData.copyCvSelected = this.cvs[0].id;
  },
  methods: {
    async onSubmit() {
      const {
        title,
        templateCvDesignTemplateSelected,
        templateCvExampleSelected,
        copyCvSelected,
        initialCvType,
      } = this.formData;
      if (initialCvType === this.SCRATCH_FLAG) {
        await this.$store.dispatch(
          CvsStore.CreateCvFromScratch.namespaced({
            title,
          })
        );
      } else if (initialCvType === this.DESIGN_TEMPLATE_SAMPLE) {
        await this.$store.dispatch(
          CvsStore.CreateCvFromTemplate.namespaced({
            title,
            source_id: templateCvDesignTemplateSelected,
          })
        );
      } else if (initialCvType === this.CV_EXAMPLE) {
        const payload = inputValueToPayload(templateCvExampleSelected);
        await this.$store.dispatch(
          CvsStore.CreateCvFromExample.namespaced({
            title,
            source_id: payload.sourceId,
            source_type: payload.sourceType,
          })
        );
      } else if (initialCvType === this.COPY_CREATED_CV) {
        await this.$store.dispatch(
          CvsStore.CreateCvFromCopy.namespaced({
            title,
            source_id: copyCvSelected,
          })
        );
      }

      const latestCv = this.$store.getters['cvs/latestCv'];

      this.$notifySuccess(i18n.tc(i18nHints.common.notification.created));
      // NOTE: go to profile edit page
      this.$router.push({
        name: this.$ua.isMobile
          ? 'cv_edit_path'
          : 'cv_section_profile_edit_path',
        params: { cv_id: latestCv.id },
      });
    },
  },
});
